import { ContactSearchDto } from '@app/api2/api';
import * as Yup from 'yup';

export const ContactSearchSchema: Yup.SchemaOf<ContactSearchDto> = Yup.object({
    discriminator: Yup.string().required(),
    operator: Yup.string().optional(),
    addressLine1: Yup.string().optional().test(
        'at-least-one-field',
        'At least one search field is required',
        function (value) {
            const { city, state, postalCode, country, emailAddress, phoneNumber } = this.parent;
            return !!value || !!city || !!state || !!postalCode || !!country || !!emailAddress || !!phoneNumber;
        }
    ),
    city: Yup.string().optional().test(
        'at-least-one-field',
        'At least one search field is required',
        function (value) {
            const { addressLine1, state, postalCode, country, emailAddress, phoneNumber } = this.parent;
            return !!value || !!addressLine1 || !!state || !!postalCode || !!country || !!emailAddress || !!phoneNumber;
        }
    ),
    state: Yup.string().optional().test(
        'at-least-one-field',
        'At least one search field is required',
        function (value) {
            const { addressLine1, city, postalCode, country, emailAddress, phoneNumber } = this.parent;
            return !!value || !!addressLine1 || !!city || !!postalCode || !!country || !!emailAddress || !!phoneNumber;
        }
    ),
    postalCode: Yup.string().optional().test(
        'at-least-one-field',
        'At least one search field is required',
        function (value) {
            const { addressLine1, city, state, country, emailAddress, phoneNumber } = this.parent;
            return !!value || !!addressLine1 || !!city || !!state || !!country || !!emailAddress || !!phoneNumber;
        }
    ),
    country: Yup.string().optional().test(
        'at-least-one-field',
        'At least one search field is required',
        function (value) {
            const { addressLine1, city, state, postalCode, emailAddress, phoneNumber } = this.parent;
            return !!value || !!addressLine1 || !!city || !!state || !!postalCode || !!emailAddress || !!phoneNumber;
        }
    ),
    emailAddress: Yup.string().optional().email('Invalid email address').test(
        'at-least-one-field',
        'At least one search field is required',
        function (value) {
            const { addressLine1, city, state, postalCode, country, phoneNumber } = this.parent;
            return !!value || !!addressLine1 || !!city || !!state || !!postalCode || !!country || !!phoneNumber;
        }
    ),
    phoneNumber: Yup.string().optional().test(
        'at-least-one-field',
        'At least one search field is required',
        function (value) {
            const { addressLine1, city, state, postalCode, country, emailAddress } = this.parent;
            return !!value || !!addressLine1 || !!city || !!state || !!postalCode || !!country || !!emailAddress;
        }
    ),
});
